export default "__VITE_ASSET__18012d97__"